var _path, _path2, _path3, _ellipse, _rect, _path4, _path5, _rect2, _path6, _polygon, _path7, _path8, _polygon2, _path9, _path0, _path1, _circle, _path10, _path11, _rect3, _path12, _polygon3, _path13, _polygon4, _path14, _path15, _polygon5, _circle2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect4, _path24, _path25, _path26, _path27, _rect5, _path28, _path29, _path30, _path31, _path32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeetingOut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 785.77114,
    height: 658,
    viewBox: "0 0 785.77114 658",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M992.88557,299.75238c0,3.93381-.126,7.85148-.378,11.72229a178.02767,178.02767,0,0,1-16.66336,64.54594c-.07837.17288-.15751.34652-.23588.50325-.44025.94427-.89663,1.87317-1.36915,2.8013a179.0123,179.0123,0,0,1-156.093,99.21032l1.7779,101.71274,23.052-12.14793,4.12281,7.83688-27.0019,14.20857,3.13168,179.41312L823.38611,779h-17.6714l.17364-9.44114,5.36519-291.00724a178.27475,178.27475,0,0,1-126.14922-54.8843c-1.1325-1.16478-2.23428-2.36029-3.33528-3.55656-.04764-.04687-.07914-.09451-.11064-.126A178.929,178.929,0,0,1,649.0708,369.569c.17287.20515.36188.378.53475.58239a178.86982,178.86982,0,0,1,84.81351-230.505c.61312-.29888,1.25851-.59852,1.8724-.91276a179.01325,179.01325,0,0,1,231.921,70.41515c1.08563,1.82476,2.14054,3.69793,3.147,5.57033A177.89459,177.89459,0,0,1,992.88557,299.75238Z",
    transform: "translate(-207.11443 -121)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M249.38531,751.0873c-12.94016,9.64624-16.60754,26.61846-16.60754,26.61846s17.31272,1.33261,30.25288-8.31365,16.60753-26.61846,16.60753-26.61846S262.32547,741.44108,249.38531,751.0873Z",
    transform: "translate(-207.11443 -121)",
    fill: "#f1f1f1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.7756,755.61622c-6.21915,14.89361-21.79488,22.5685-21.79488,22.5685s-5.49247-16.47239.72668-31.366,21.79485-22.5685,21.79485-22.5685S260.99476,740.72261,254.7756,755.61622Z",
    transform: "translate(-207.11443 -121)",
    fill: "#f1f1f1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.61417,
    cy: 474,
    rx: 110.5,
    ry: 23,
    fill: "#cacaca"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 313.11417,
    y: 485.28279,
    width: 13,
    height: 172,
    fill: "#cacaca"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M602.71466,584.1179a11.003,11.003,0,0,1,15.87365-4.19121,10.59626,10.59626,0,0,1,1.163.89958l47.72357-11.30154,3.51936-11.67976,19.03808,3.1253-3.89118,19.61937a11.1485,11.1485,0,0,1-9.90645,8.891l-53.99132,4.75563a10.51178,10.51178,0,0,1-.54448.933,11.00315,11.00315,0,0,1-16.248,2.36254,10.70561,10.70561,0,0,1-.98068-.92681A11.036,11.036,0,0,1,602.71466,584.1179Z",
    transform: "translate(-207.11443 -121)",
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M706.19645,667.19771H658.18669c0,1.38-49.48,2.5-49.48,2.5a12.86044,12.86044,0,0,0-2.10987,2,12.41036,12.41036,0,0,0-2.90039,8v2a12.50462,12.50462,0,0,0,12.5,12.5h90a12.51087,12.51087,0,0,0,12.5-12.5v-2A12.51738,12.51738,0,0,0,706.19645,667.19771Z",
    transform: "translate(-207.11443 -121)",
    fill: "#e4e4e4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 446.85845,
    y: 572.70113,
    width: 13,
    height: 84,
    fill: "#e4e4e4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M616.97288,777.24446c0,1.4046,19.69946.54334,44,.54334s44,.86132,44-.54334-19.69946-12.54333-44-12.54333S616.97288,775.8398,616.97288,777.24446Z",
    transform: "translate(-207.11443 -121)",
    fill: "#e4e4e4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "422.594 645.399 410.335 645.398 404.502 613.601 422.596 613.602 422.594 645.399",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M632.83525,778.28279l-39.53052-.00146v-.5a15.386,15.386,0,0,1,15.38586-15.38623h.00159l24.1438.001Z",
    transform: "translate(-207.11443 -121)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M611.372,746.68111l-24.44092-54.80768a20.086,20.086,0,0,1,8.8186-25.78418l53.01343-28.42774,24.19116-2.05761,22.3147-2.02832.16089.27246c.20581.34765,5.00366,8.63476,1.7605,17.72168-2.46,6.89257-8.85889,12.27636-19.0188,16.002-23.71436,8.69531-51.10913,16.127-61.78638,18.918a3.451,3.451,0,0,0-2.21118,1.75977,3.49833,3.49833,0,0,0-.19629,2.79882l22.70654,51.01465a4.49993,4.49993,0,0,1-3.80932,6.0293l-16.96655,1.23535q-.21607.02051-.43018.02051A4.49693,4.49693,0,0,1,611.372,746.68111Z",
    transform: "translate(-207.11443 -121)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "430.594 645.399 418.335 645.398 412.502 613.601 430.596 613.602 430.594 645.399",
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M640.83525,778.28279l-39.53052-.00146v-.5a15.386,15.386,0,0,1,15.38586-15.38623h.00159l24.1438.001Z",
    transform: "translate(-207.11443 -121)",
    fill: "#2f2e41"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M620.372,749.68111l-24.44092-54.80768a20.086,20.086,0,0,1,8.8186-25.78418l53.01343-28.42774,24.19116-2.05761,17.478-1.51611-.00239-.23975c.20581.34765,5.00366,8.63476,1.7605,17.72168-2.46,6.89257-3.85889,12.27636-14.0188,16.002-23.71436,8.69531-51.10913,16.127-61.78638,18.918a3.451,3.451,0,0,0-2.21118,1.75977,3.49833,3.49833,0,0,0-.19629,2.79882l22.70654,51.01465a4.49993,4.49993,0,0,1-3.80932,6.0293l-16.96655,1.23535q-.21607.02051-.43018.02051A4.49693,4.49693,0,0,1,620.372,749.68111Z",
    transform: "translate(-207.11443 -121)",
    fill: "#2f2e41"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M666.43224,638.08779c-1.17181-.82892-18,8-21,1,14-35,4.35253-50.11365,12.92821-70.18446a24.99164,24.99164,0,0,1,16.5669-14.17968l22.24951-1.12305.11523.05566a26.00518,26.00518,0,0,1,14.2193,27.58835c-.07915,21.84318-13.14843,38.5029-8.57861,54.34616a5.12184,5.12184,0,0,1-.48389,3.9834,4.88414,4.88414,0,0,1-3.11572,2.30908l-29.37848-3.91894a4.96433,4.96433,0,0,1-4.0166-.77734Z",
    transform: "translate(-207.11443 -121)",
    fill: "#dadada"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 482.63708,
    cy: 399.72927,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M697.57478,543.27319c-1.305.571-3.97732-9.82732-2.78025-11.90707,1.78025-3.09293,1.675-3.07072,2.85681-5.117s1.44624-4.84712-.08417-6.64761-5.072-1.56163-5.77042.69581c.4493-4.2878-3.79189-7.73454-7.99295-8.70313s-8.63245-.36723-12.85668-1.22917c-4.90244-1.00032-10.00317-5.10972-8.0472-10.5007a7.59327,7.59327,0,0,1,1.48106-2.43408c2.25993-2.54094,5.42117-3.62594,8.512-4.675,6.43006-2.18246,13.03605-4.39233,19.82212-4.15141A28.7977,28.7977,0,0,1,718.1614,507.213a26.15571,26.15571,0,0,1,1.08344,4.02534c2.32924,12.52423-4.94368,24.87794-16.75622,29.64715Z",
    transform: "translate(-207.11443 -121)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M334.78244,659.95906h37.53047c0,1.60811,41.02578,2.91323,41.02578,2.91323a14.98705,14.98705,0,0,1,2.45861,2.33058,14.46168,14.46168,0,0,1,3.3798,9.32233v2.33058A14.57152,14.57152,0,0,1,404.611,691.42193H334.78244a14.57882,14.57882,0,0,1-14.56614-14.56615V674.5252A14.5864,14.5864,0,0,1,334.78244,659.95906Z",
    transform: "translate(-207.11443 -121)",
    fill: "#e4e4e4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 154.96001,
    y: 569.84326,
    width: 15.14879,
    height: 87.43953,
    fill: "#e4e4e4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M421.42629,776.66336c0,1.63677-22.95562.63314-51.27282.63314s-51.27282,1.0037-51.27282-.63314,22.95561-14.61664,51.27282-14.61664S421.42629,775.02652,421.42629,776.66336Z",
    transform: "translate(-207.11443 -121)",
    fill: "#e4e4e4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "224.488 645.672 235.762 645.672 241.126 602.185 224.486 602.186 224.488 645.672",
    fill: "#9f616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M428.7266,762.99134l22.20329-.0009h.0009a14.15045,14.15045,0,0,1,14.14968,14.14945v.45981l-36.35319.00135Z",
    transform: "translate(-207.11443 -121)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "257.81 645.672 269.085 645.672 274.448 602.185 257.808 602.186 257.81 645.672",
    fill: "#9f616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M462.04883,762.99134l22.20329-.0009h.0009a14.15043,14.15043,0,0,1,14.14967,14.14945v.45981l-36.35319.00135Z",
    transform: "translate(-207.11443 -121)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M425.68469,629.04065a8.57194,8.57194,0,0,0-11.05415-7.11142l-12.54786-15.04184L391.082,612.28325l18.01834,20.9931a8.61841,8.61841,0,0,0,16.58434-4.2357Z",
    transform: "translate(-207.11443 -121)",
    fill: "#9f616a"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "176.375 418.822 183.735 421.843 185.517 442.634 205.23 496.548 188.487 502.121 169.885 465.956 176.375 418.822",
    fill: "#e4e4e4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.26335,
    cy: 375.1836,
    r: 19.60295,
    fill: "#9f616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M361.362,487.06183s.86028-11.9088,11.473-7.05306,9.92021-8.52827,6.71311-10.89338-3.10554-2.9504-14.83522-1.368-34.50222,4.2635-27.13886,27.84837,18.20751,17.44483,18.20751,17.44483-10.02833-21.15047-4.09789-17.10708l5.93043,4.0434,3.12951-.66286Z",
    transform: "translate(-207.11443 -121)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M332.20474,631.02333s-6.57742,34.78018,18.44848,39.20919,61.15139,7.54182,61.15139,7.54182l16.22277,75.68924,21.795-1.9458s-2.89864-91.11294-10.027-98.24129-41.02162-27.9889-41.02162-27.9889Z",
    transform: "translate(-207.11443 -121)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M381.082,616.4467l10.94516,10.98018s79.03027,12.72967,82.07906,30.98305c4.603,27.55827,10.03978,87.48563,10.03978,87.48563l-23.76115-1.78209-9.31773-68.12122-38.01794-8.64786L369.79545,643.772Z",
    transform: "translate(-207.11443 -121)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M380.47317,532.24773l-6.3576-8.42917-20.617-.33737,0,0a40.16435,40.16435,0,0,0-21.29376,35.45526v53.33567s.293,7.09755-1.2592,23.39617c-1.33934,14.063,73.49962-8.24142,73.49962-8.24142l-9.7153-79.15083S395.51063,535.668,380.47317,532.24773Z",
    transform: "translate(-207.11443 -121)",
    fill: "#e4e4e4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M960.11443,779h-752a1,1,0,1,1,0-2h752a1,1,0,1,1,0,2Z",
    transform: "translate(-207.11443 -121)",
    fill: "#cacaca"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M593.32739,524.43465h0a81.636,81.636,0,0,1-.685-17.69627l.685-9.77469h0c-3.77456,7.51053-2.92153,17.39572,0,27.47094Z",
    transform: "translate(-207.11443 -121)",
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M596.2707,526.06982h0a60.01056,60.01056,0,0,1-.32959-10.53349l.32959-5.81827h0C594.45464,514.18863,594.86507,520.07265,596.2707,526.06982Z",
    transform: "translate(-207.11443 -121)",
    fill: "#e6e6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M609.35363,533.26538v3.27035a.98619.98619,0,0,1-.9811.98111h-1.63518a.32587.32587,0,0,0-.327.327v26.81689a.9862.9862,0,0,1-.98111.98111H585.48006a.98186.98186,0,0,1-.98111-.98111V537.84387a.328.328,0,0,0-.327-.327h-1.96221a.98186.98186,0,0,1-.98111-.98111v-3.27035a.97976.97976,0,0,1,.98111-.98111h26.16282A.98405.98405,0,0,1,609.35363,533.26538Z",
    transform: "translate(-207.11443 -121)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 377.41391,
    y: 417.2036,
    width: 21.91136,
    height: 0.98111,
    fill: "#dadada"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M606.41032,552.64052a28.15951,28.15951,0,0,1-22.2384,0v-6.91194a34.92406,34.92406,0,0,1,22.2384,0Z",
    transform: "translate(-207.11443 -121)",
    fill: "#dadada"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M458.32739,546.43465h0a81.636,81.636,0,0,1-.685-17.69627l.685-9.77469h0c-3.77456,7.51053-2.92153,17.39572,0,27.47094Z",
    transform: "translate(-207.11443 -121)",
    fill: "#e6e6e6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M461.2707,548.06982h0a60.01056,60.01056,0,0,1-.32959-10.53349l.32959-5.81827h0C459.45464,536.18863,459.86507,542.07265,461.2707,548.06982Z",
    transform: "translate(-207.11443 -121)",
    fill: "#e6e6e6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M474.35363,555.26538v3.27035a.98619.98619,0,0,1-.9811.98111h-1.63518a.32587.32587,0,0,0-.327.327v26.81689a.9862.9862,0,0,1-.98111.98111H450.48006a.98186.98186,0,0,1-.98111-.98111V559.84387a.328.328,0,0,0-.327-.327h-1.96221a.98186.98186,0,0,1-.98111-.98111v-3.27035a.97976.97976,0,0,1,.98111-.98111h26.16282A.98405.98405,0,0,1,474.35363,555.26538Z",
    transform: "translate(-207.11443 -121)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 242.41391,
    y: 439.2036,
    width: 21.91136,
    height: 0.98111,
    fill: "#dadada"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M471.41032,574.64052a28.15951,28.15951,0,0,1-22.2384,0v-6.91194a34.92406,34.92406,0,0,1,22.2384,0Z",
    transform: "translate(-207.11443 -121)",
    fill: "#dadada"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M643.36045,603.95943l-42.67431-33.666a10.51483,10.51483,0,0,1-1.03614.30566,11.02708,11.02708,0,0,1-8.81787-1.6914,10.91268,10.91268,0,0,1-4.62646-7.7334,11.00127,11.00127,0,0,1,21.63525-3.80078,10.57394,10.57394,0,0,1,.229,1.45215L650.55137,583.333l10.57178-6.08642,11.71094,15.332L656.42,604.27779A10.94192,10.94192,0,0,1,643.36045,603.95943Z",
    transform: "translate(-207.11443 -121)",
    fill: "#ffb8b8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M678.04136,597.35329l-24.34869-16.55738,11.44287-16.20685a11.16825,11.16825,0,0,1,13.92865-3.64h0a11.16823,11.16823,0,0,1,5.89441,13.28259Z",
    transform: "translate(-207.11443 -121)",
    fill: "#dadada"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M458.99115,565.66965a8.57193,8.57193,0,0,0-12.154,5.00476l-19.51476,1.697L425.46128,584.482l27.525-2.78353a8.61841,8.61841,0,0,0,6.00491-16.0288Z",
    transform: "translate(-207.11443 -121)",
    fill: "#9f616a"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M342.42059,547.90683l-5.51987,4.11809s-3.06325,7.412,2.9394,17.25149,44.0397,30.58249,44.0397,30.58249l61.58427-15.72681-8.77536-17.21682-44.87412,1.25491S366.44077,536.54079,342.42059,547.90683Z",
    transform: "translate(-207.11443 -121)",
    fill: "#e4e4e4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingOut);
export default __webpack_public_path__ + "static/media/meeting_out.5a35b939690fcacc3f6d7c836151769b.svg";
export { ForwardRef as ReactComponent };